// import { useState } from "react";
import {collection, getDocs, query, where} from 'firebase/firestore';
import {getDb} from 'util/Constants';
import React, {useEffect, useState} from 'react';
import {Link, useHistory, useLocation} from 'react-router-dom';
import {Button, Card, CardBody, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import step1 from "../../assets/img/icons/user/step-counting/step-1.png";
import step2 from "../../assets/img/icons/user/step-counting/step-2.png";
import step3 from "../../assets/img/icons/user/step-counting/step-3.png";
import step4 from "../../assets/img/icons/user/step-counting/step-4.png";


const Dashboard = ({ signedInUser }, props) => {
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [events, setEvents] = useState([]);
    const [event, setEvent] = useState({});
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const value = queryParams.get('id');


    useEffect(() => {
        getEvents().then(r => {
        })
    }, [])

    const getEvents = async () => {
        setLoading(true)
        let eventRef = "";
        if (signedInUser.role !== "superAdmin") {
            eventRef = query(collection(getDb(), "Events"), where("userId", "==", signedInUser.uid));
        } else {
            eventRef = query(collection(getDb(), "Events"), where("userId", "==", value));
        }
        const querySnapshot = await getDocs(eventRef);
        let arr = [];

        querySnapshot.forEach((doc) => {
            arr.push({ id: doc.id, ...doc.data() })
        });
        setEvents(arr);
        setLoading(false)
    }

    const toggle = (eventId) => {
        if (eventId) {
            const eventData = events.find((e) => e.eventId === eventId)
            setEvent(eventData);
        } else {
            setEvent({})
        }
        setModal(!modal)
    };
    const push = (id) => {
        history.push('/admin/leaderboard/' + id)
        localStorage.setItem('eventId', id);
    }


    return (
        <div>
            <Container>
                <div className="d-flex justify-content-center mt--200 flex-column align-items-center">
                    <div className="mb-lg-5">
                        <Link to='/easy-flow/index'>  <Button className="createAssessment text-white" color="">+ Create New Assessment Game</Button></Link>
                    </div>
                    <Card className="br-60 step1-card">
                        <CardBody className="pt-3">
                            <Row className="px-4 pt-3">
                                <Col sm={12} lg={4} md={4}>
                                    <div className="dashboard-info">My Assessment Games</div>
                                </Col>
                                <Col sm={12} lg={4} md={4}></Col>
                                <Col sm={12} lg={4} md={4}>
                                    <div className="dashboard-info"> Total Number of Games : {events.length}</div>
                                </Col>
                            </Row>
                            <Container className="assessment-listing mt-3">
                                {!loading && events.map((item, index) => (
                                    <div onClick={() => push(item.eventId)} style={{ cursor: 'pointer' }} className="assessment-entity" key={index}>
                                        <div>{item.difficulty}</div>
                                        <Row className='d-flex justify-content-between mb-2'>
                                            <Col>
                                                <h1 className="text-white">{item.assessmentName}</h1>
                                            </Col>
                                            <Col className="text-right">
                                                <span onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggle(item.eventId)
                                                }} style={{ cursor: "pointer" }} class="badge badge-secondary text-bold">Details</span>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div><span>Launch Date : {item.launchDate}</span></div>
                                                <div><span>Closing Date : {item.closingDate}</span></div>
                                            </Col>
                                            <Col className="text-center">
                                                {/* <div><span>Total Registrations : {item.totalResgistrations}</span></div>
                                                <div><span>Games Played : {item.gamesPlayed}</span></div> */}
                                            </Col>
                                            <Col className="text-right">
                                                <Button className="footerButton text-white" color="">Free</Button>
                                            </Col>
                                        </Row>
                                    </div>
                                ))}
                            </Container>
                            <h2 className="text-center">Assessments Selected</h2>
                        </CardBody>
                    </Card>
                </div>
            </Container>
            <div>

                <Modal size="lg" style={{ maxWidth: '1200px', width: '100%' }} isOpen={modal} toggle={toggle} >
                    <ModalHeader toggle={toggle}>Modal title</ModalHeader>
                    <ModalBody>
                        {event?.hasOwnProperty('assessmentName') && <Row>
                            <Col>
                                <div className="listing-header pt-1">
                                    <img src={step1} height={55} />
                                    <span className="text-white ml-2">Get Started</span>
                                </div>
                                <div className="mt-3">
                                    <div>
                                        <label className="listing-item">{event.assessmentName}</label>
                                    </div>
                                    <div>
                                        <label
                                            className="listing-item mt-2">{event.assessmentFor}</label>
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div className="listing-header pt-1">
                                    <img src={step2} height={55} />
                                    <span className="text-white ml-2">Chosen Assessments</span>
                                </div>
                                <div className="mt-3">
                                    {event.selectedCompetencies && Object.keys(event?.selectedCompetencies).map((ability) => (
                                        <div>
                                            <label className="list-item-heading">{ability} Assessments</label>
                                            <div>
                                                {event?.selectedCompetencies[ability].map((item) => (
                                                    <div>
                                                        <label className="listing-item">{ability === "competencies" ? item.name : item.secondName}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Col>
                            <Col>
                                <div className="listing-header pt-1">
                                    <img src={step3} height={55} />
                                    <span className="text-white ml-2">Customize</span>
                                </div>
                                <div className="mt-3">
                                    <div>
                                        <label className="list-item-heading">Registration Fields</label>
                                        <div>
                                            {event?.registrationFields.map((field) => (
                                                <div>
                                                    <label className="listing-item">{field}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div>
                                        <label className="list-item-heading">Log In Method</label>
                                        <div>
                                            {event?.loginMethod.map((field) => (
                                                <div>
                                                    <label className="listing-item">{field}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div>
                                        <label className="list-item-heading">Custom Artwork</label>
                                        <div>
                                            {event?.customArtWork &&
                                                event?.customArtWork.map((field) => (
                                                    <label className="listing-item mr-2">{field}</label>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div className="listing-header pt-1">
                                    <img src={step4} height={55} />
                                    <span className="text-white ml-2">Configure & Launch</span>
                                </div>
                                <div className="mt-3">
                                    <label className="list-item-heading">Launch Date</label>
                                    <div>
                                        <label className="listing-item">{event?.launchDate}</label>
                                    </div>
                                    <label className="list-item-heading">Closing Date</label>
                                    <div>
                                        <label className="listing-item">{event?.closingDate}</label>
                                    </div>
                                </div>
                            </Col>
                        </Row>}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggle}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        </div>




    );
};

export default Dashboard;